import { Add, DeleteOutline } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import offerImg from "../../assets/svg/defultImage.svg"
import "./OfferProfile.css"
import { EditIcon } from "lucide-react";
import { DataGrid } from '@mui/x-data-grid';
import { Autocomplete, FormControl, IconButton, Paper, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import axios from 'axios';
import { newHost } from './../Categories/CategoryProfile';
import { toast } from 'react-toastify';
import DeleteModal from '../../components/Modals/DeleteModal';
import { useSelector } from 'react-redux';

const OfferProfile = () => {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id: offerId } = useParams()
  const [offerData, setOfferData] = useState({})
  const [showSuspend, setShowSuspend] = useState(false);
  const [itemTypes, setItemTypes] = useState([])
  const [itemRoles, setItemRoles] = useState([])
  const [discountTypes, setDiscountTypes] = useState([])
  const [services, setServices] = useState([])
  const [products, setProduts] = useState([])
  const [selectedDicountRole, setSelectedDiscountRole] = useState(false)
  const [itemId, setItemId] = useState("")

  const navigate = useNavigate()

  const handleEditOffer = () => {
    navigate(`/offers/edit/${offerId}`);
  }

  const handleCloesSuspend = () => {
    setShowSuspend(false);
  };

  const handleSubmitSuspnd = () => {
    setShowSuspend(false);
  };

  const handleSuspendShow = () => {
    setShowSuspend(true);
  };

  const [showAddItem, setShowItem] = useState(false)

  const handleAddItemShow = () => {
    setShowItem(true)

  }

  const handleAddItemClose = () => {
    setShowItem(false)
    setSelectedDiscountRole(false)
    reset()
  }

  const [showUpdateItem, setShowUpdate] = useState(false)

  const [serviceType, setServiceType] = useState(false)

  const handleUpdateItemShow = (e, item) => {
    setShowUpdate(true)
    e.stopPropagation()
    setItemId(item.id)
    if (item.item_type == "service") {
      setServiceType(true)
    } else {
      setServiceType(false)

    }
    if (item.item_role == "discounted_item") {

      updateValue("discount_type", item.discount_type)
      updateValue("discount_value", item.discount_value)
    }

    updateValue("quantity", item.quantity)
    updateValue("item_id", item.item_id)
    updateValue("item_type", item.item_type)
    updateValue("item_role", item.item_role)
    updateValue("quantity", item.quantity)


  }

  const handleUpdateItemClose = () => {
    setShowUpdate(false)
    resetUpdate()
  }

  const columns = [
    {
      field: "item",
      headerName: "Item Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <p className="m-0">{params.row.item?.name}</p>
        )
      }
    },
    {
      field: "item_type",
      headerName: "Item Type",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "item_role_label",
      headerName: "Item Role",
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "discount_type_label",
      headerName: "Discount Type",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "discount_value",
      headerName: "Discount Value",
      flex: 0.8,
      minWidth: 110,
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={(e) => handleUpdateItemShow(e, params.row)}
              color="default"
              aria-label="edit"
              size="small"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={(e) => confirmDelete(e, params.row?.id)}
              color="error"
              aria-label="delete"
              size="small"
            >
              <DeleteOutline />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      items: [{ item_id: "", quantity: 1, item_type: "", item_role: "" }],
    },
  });

  const {
    register: updateRegister,
    handleSubmit: submitUpdate,
    setValue: updateValue,
    control: controlUpdate,
    reset: resetUpdate,
    watch: UpdateWatch

  } = useForm(
    );

  const { fields: itemFields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const getOfferById = async () => {
    try {
      const response = await axios.get(`${newHost}portal/offers/${offerId}`, {
        headers: newHeaders
      })
      console.log(response);
      setOfferData(response.data.data?.offer)

    } catch (error) {

    }
  }

  const getItemTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/item-types`, {
        headers: newHeaders
      })
      console.log(response);
      setItemTypes(response.data.data?.item_types)
    } catch (error) {
      console.log(error);

    }
  }

  const getItemRoles = async () => {
    try {
      const response = await axios.get(`${newHost}portal/item-roles`, {
        headers: newHeaders
      })
      console.log(response);
      setItemRoles(response.data.data?.item_roles)
    } catch (error) {
      console.log(error);

    }
  }

  const getDiscountTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/discount-types`, {
        headers: newHeaders
      })
      console.log(response);
      setDiscountTypes(response.data.data?.discount_types)
    } catch (error) {
      console.log(error);

    }
  }

  const getallservices = async () => {
    try {
      const response = await axios.get(`${newHost}portal/door_step_services`, {
        headers: newHeaders
      })
      console.log(response);
      setServices(response.data?.data?.services)
    } catch (error) {
      console.log(error);

    }
  }

  const getallProducts = async () => {
    try {
      const response = await axios.get(`${newHost}portal/product_variations`, {
        headers: newHeaders
      })
      console.log(response);
      setProduts(response.data.data?.variations)
    } catch (error) {
      console.log(error);

    }
  }

  const submitItem = async (data) => {

    console.log(data);
    try {
      const response = await axios.post(`${newHost}portal/offers/${offerId}/items`, data, {
        headers: newHeaders
      })
      console.log(response);
      toast.success(response.data?.data.message)
      setShowItem(false)
      getOfferById()
      reset()

    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message)
    }
  }

  const updateItem = async (data) => {
    console.log(data);
    try {
      const response = await axios.post(`${newHost}portal/offers/${offerId}/items/${itemId}`, {
        ...data,
        _method: "PUT"
      }, {
        headers: newHeaders
      })
      console.log(response);
      toast.success(response.data?.data.message)
      setShowUpdate(false)
      getOfferById()

    } catch (error) {
      console.log(error);
      toast.error(error.response.data.errors.message)

    }
  }

  const deleteItem = async () => {
    try {
      const response = await axios.post(`${newHost}portal/offers/${offerId}/items`, {
        item_ids: [itemId],
        _method: "DELETE"
      }, {
        headers: newHeaders
      })
      console.log(response);
      toast.success(response.data?.data.message)
      setShowDelete(false)
      getOfferById()
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.errors.message)

    }
  }
  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (e, id) => {
    setShowDelete(true);
    setItemId(id);
    e.stopPropagation()
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setItemId(null)
  };

  useEffect(() => {
    getOfferById()
    getItemTypes()
    getItemRoles()
    getDiscountTypes()
    getallservices()
    getallProducts()
  }, [])

  return (
    <>
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to remove this item from offer?"}
        deleteFunction={deleteItem}
      />

      <Modal show={showSuspend} onHide={handleCloesSuspend}>
        <Modal.Header>
          <Modal.Title className="titleModel_sus-delet">
            Suspend Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="deleteOrderMasege_sus">
            Are you want to suspend this Offer
          </div>
          <div className="deleteOrderMasege_sus-span">
            20% Discount on Maintenance
          </div>
          <div className="OrdersTable-footer">
            <button onClick={handleCloesSuspend} className="ordersCancelTable">
              Cancel
            </button>
            <button
              onClick={handleSubmitSuspnd}
              className=" deletOrderbutton_sus "
            >
              Suspend
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showAddItem} onHide={handleAddItemClose}>
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black">Add new Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(submitItem)}>
            {itemFields.map((item, index) => {
              const itemTypesValues = watch("items");

              const itemType = itemTypesValues?.[index]?.item_type;
              const isProduct = itemType == "product";
              const isService = itemType == "service";
              return (
                <>
                  <div className="">
                    <Controller
                      name={`items.${index}.item_type`}
                      control={control}
                      render={({ field }) => (
                        <FormControl className="w-100 mb-2" variant="outlined">
                          <label>Item Type</label>
                          <Autocomplete
                            size="small"
                            options={itemTypes.map((option) => {
                              console.log(option);

                              return {
                                label: option.label,
                                id: option.value,
                              };
                            })}
                            onChange={(e, item) => {
                              field.onChange(item ? item.id : null);
                            }}
                            value={field.value || ""}
                            renderOption={(props, option) => (
                              <li {...props} className="p-2">
                                {option.label}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Item Type"
                              />
                            )}
                          />
                          {/* <Select
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                                handleItemsTypesChange(e.target.value);
                              }}
                            >
                              {itemTypes.map((type) => (
                                <MenuItem
                                  key={type.id}
                                  value={type.value}
                                  className="custom-menu-item"
                                >
                                  <div className="label-size m-0">
                                    {type.label}
                                  </div>
                                </MenuItem>
                              ))}
                            </Select> */}
                        </FormControl>
                      )}
                    />
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <Controller
                        name={`items.${index}.item_id`}
                        control={control}
                        render={({ field }) => (
                          <FormControl
                            className="w-100 mb-2"
                            variant="outlined"
                          >
                            <label htmlFor="">Services</label>
                            <Autocomplete
                              disabled={!isService}
                              size="small"
                              options={services.map((option) => {
                                console.log(option);

                                return {
                                  label: option.name,
                                  id: option.id,
                                };
                              })}
                              onChange={(e, item) => {
                                field.onChange(item ? item.id : null);
                              }}
                              renderOption={(props, option) => (
                                <li
                                  style={{ direction: "rtl" }}
                                  {...props}
                                  className="p-2"
                                >
                                  {option.label}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Service"
                                />
                              )}
                            />
                          </FormControl>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row align-items-center" key={item.id}>
                    <div className="col-md-6 col-sm-12">
                      <div>
                        <Controller
                          name={`items.${index}.item_id`}
                          control={control}
                          render={({ field }) => (
                            <FormControl className="w-100  " variant="outlined">
                              <label htmlFor="">Products</label>
                              <Autocomplete
                                disabled={!isProduct}
                                size="small"
                                options={products.map((option) => {
                                  console.log(option);

                                  return {
                                    label: option.sku,
                                    id: option.id,
                                  };
                                })}
                                onChange={(e, item) => {
                                  field.onChange(item ? item.id : null);
                                }}
                                renderOption={(props, option) => (
                                  <li {...props} className="p-2">
                                    {option.label}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Product"
                                  />
                                )}
                              />
                            </FormControl>
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 ">
                      <div>
                        <label className="w-100" htmlFor="">
                          Quantity
                        </label>
                        <TextField
                          sx={{ height: "50px" }}
                          size="small"
                          disabled={!isProduct}
                          className="w-100"
                          {...register(`items.${index}.quantity`, {
                            valueAsNumber: true,
                          })}
                          type="number"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <Controller
                      name={`items.${index}.item_role`}
                      control={control}
                      render={({ field }) => (
                        <FormControl className="w-100 mb-2" variant="outlined">
                          <label htmlFor="">Item Role</label>
                          <Autocomplete
                            size="small"
                            options={itemRoles.map((option) => {
                              return {
                                label: option.label,
                                id: option.value,
                              };
                            })}
                            onChange={(e, item) => {
                              field.onChange(item ? item.id : null);
                            }}
                            value={field.value || ""}
                            renderOption={(props, option) => (
                              <li {...props} className="p-2">
                                {option.label}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Item Role"
                              />
                            )}
                          />
                          {/* <Select
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 200,
                                    overflowY: "scroll",
                                    width: "auto",
                                  },
                                },
                              }}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                                // ItemRoleChange(e.target.value)
                              }}
                            >
                              {itemRoles.map((role) => (
                                <MenuItem
                                  // key={type.id}
                                  value={role.value}
                                  className="custom-menu-item"
                                >
                                  <div className="label-size m-0">
                                    {" "}
                                    {role.label}
                                  </div>
                                </MenuItem>
                              ))}
                            </Select> */}
                        </FormControl>
                      )}
                    />
                  </div>
                  {watch(`items.${index}.item_role`) == "discounted_item" && (
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <Controller
                          name={`items.${index}.discount_type`}
                          control={control}
                          render={({ field }) => (
                            <FormControl
                              className="w-100 mb-4"
                              variant="outlined"
                            >
                              <label htmlFor="">Discount Type (Optional)</label>
                              <Autocomplete
                                size="small"
                                options={discountTypes.map((option) => {
                                  console.log(option);

                                  return {
                                    label: option.label,
                                    id: option.value,
                                  };
                                })}
                                onChange={(e, item) => {
                                  field.onChange(item ? item.id : null);
                                }}
                                value={field.value || ""}
                                renderOption={(props, option) => (
                                  <li {...props} className="p-2">
                                    {option.label}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Discount Type"
                                  />
                                )}
                              />
                              {/* <Select
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: 200,
                                        overflowY: "scroll",
                                        width: "auto",
                                      },
                                    },
                                  }}
                                  value={field.value || ""}
                                  onChange={(e) =>
                                    field.onChange(e.target.value)
                                  }
                                >
                                  {discountTypes.map((discount) => (
                                    <MenuItem
                                      // key={type.id}
                                      value={discount.value}
                                      className="custom-menu-item"
                                    >
                                      <div className="label-size m-0">
                                        {" "}
                                        {discount.label}
                                      </div>
                                    </MenuItem>
                                  ))}
                                </Select> */}
                            </FormControl>
                          )}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <label htmlFor="">Discount Value (Optional)</label>
                        <TextField
                          size="small"
                          {...register(`items.${index}.discount_value`)}
                          type="text"
                          placeholder="Enter Value"
                        />
                      </div>
                    </div>
                  )}

                  <div className="d-flex justify-content-end align-items-center gap-2">
                    <div className="">
                      <button
                        type="button"
                        onClick={() => append({ item_id: "", quantity: 1 })}
                        className="btn btn-light "
                      >
                        +
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        onClick={() => remove(index)}
                        className="btn btn-light"
                      >
                        -
                      </button>
                    </div>
                  </div>
                </>
              );
            })}

            <div className="d-flex justify-content-center align-items-center gap-3 py-4">
              <button
                type="reset"
                className="btn btn-light px-5"
                onClick={() => handleAddItemClose()}
              >
                {" "}
                Cancel{" "}
              </button>
              <button className="btn btn-dark px-5"> Save </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={showUpdateItem} onHide={handleUpdateItemClose}>
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black">Update Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitUpdate(updateItem)}>
            <div className="">
              <Controller
                name={`item_type`}
                control={controlUpdate}
                render={({ field }) => {
                  const options = itemTypes.map((option) => ({
                    label: option.label,
                    id: option.value,
                  }));

                  return (
                    <>
                      <label>Item Type</label>
                      <Autocomplete
                        readOnly
                        size="small"
                        options={options}
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
                        value={
                          options.find((opt) => opt.id == field.value) || null
                        }
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Item Type"
                          />
                        )}
                      />
                    </>
                  );
                }}
              />
            </div>
            {serviceType ? (
              <div className="row my-2">
                <div className="col-md-12 col-sm-12">
                  <Controller
                    name={`item_id`}
                    control={controlUpdate}
                    render={({ field }) => {
                      const options = services.map((option) => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <>
                          <label htmlFor="">Services</label>
                          <Autocomplete
                            size="small"
                            options={options}
                            value={
                              options.find((opt) => opt.id == field.value) ||
                              null
                            }
                            onChange={(e, item) => {
                              field.onChange(item ? item.id : null);
                            }}
                            renderOption={(props, option) => (
                              <li
                                style={{ direction: "rtl" }}
                                {...props}
                                className="p-2"
                              >
                                {option.label}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Service"
                              />
                            )}
                          />
                        </>
                      );
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="row align-items-center">
                <div className="col-md-6 col-sm-12">
                  <div>
                    <Controller
                      name={`item_id`}
                      control={controlUpdate}
                      render={({ field }) => {
                        const options = products.map((option) => ({
                          label: option.name,
                          id: option.id,
                        }));

                        return (
                          <>
                            <label htmlFor="">Products</label>
                            <Autocomplete
                              size="small"
                              options={options}
                              value={
                                options.find((opt) => opt.id == field.value) ||
                                null
                              }
                              onChange={(e, item) => {
                                field.onChange(item ? item.id : null);
                              }}
                              renderOption={(props, option) => (
                                <li {...props} className="p-2">
                                  {option.label}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Products"
                                />
                              )}
                            />
                          </>
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 ">
                  <div>
                    <label className="" htmlFor="">
                      Quantity
                    </label>

                    <TextField
                      sx={{ height: "35px" }}
                      size="small"
                      className="w-100"
                      {...updateRegister(`quantity`, {
                        valueAsNumber: true,
                      })}
                      type="number"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="">
              <Controller
                name={`item_role`}
                control={controlUpdate}
                render={({ field }) => {
                  const options = itemRoles.map((option) => ({
                    label: option.label,
                    id: option.value,
                  }));

                  return (
                    <>
                      <label>Item Role</label>
                      <Autocomplete
                        size="small"
                        options={options}
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
                        value={
                          options.find((opt) => opt.id == field.value) || null
                        }
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Item Type"
                          />
                        )}
                      />
                    </>
                  );
                }}
              />
            </div>
            {UpdateWatch("item_role") == "discounted_item" && (
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <label htmlFor="">Discount Types (Optional)</label>

                  <Controller
                    name={`discount_type`}
                    control={controlUpdate}
                    render={({ field }) => {
                      const options = discountTypes.map((option) => ({
                        label: option.label,
                        id: option.value,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Item Type"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <label htmlFor="">Discount Value (Optional)</label>
                  <TextField
                    size="small"
                    {...updateRegister(`discount_value`)}
                    type="text"
                    placeholder="Enter Value"
                  />
                </div>
              </div>
            )}

            <div className="d-flex justify-content-center align-items-center gap-3 py-4">
              <button
                className="btn btn-light px-5"
                type="reset"
                onClick={() => handleUpdateItemClose()}
              >
                {" "}
                Cancel{" "}
              </button>
              <button className="btn btn-dark px-5"> Save </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <div className="min-vh-100 m-4">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="fw-semibold m-0 p-0">Offer Profile</h5>
          <div className="d-flex gap-2">
            <button onClick={handleSuspendShow} className="btn btn-danger">
              Suspend this offer
            </button>
            <button onClick={handleAddItemShow} className="btn btn-light">
              {" "}
              <Add sx={{ color: "#535353" }} /> Add Item{" "}
            </button>
          </div>
        </div>
        <div className="border border-2 rounded-4 my-4 min-vh-100 p-4 mx-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="fw-semibold">1. Offer Info:</h6>
            <EditIcon
              className="cursor"
              onClick={() => handleEditOffer()}
              color="#535353"
            />
          </div>
          <div>
            <div style={{ width: "100px", height: "100px" }} className="my-2">
              <p className="spplier-profile-label-color m-0 p-0 fw-medium supplier-label-size">
                Offer Image
              </p>
              <img
                className="w-100 h-100 rounded-3"
                src={
                  offerData.images?.all_images?.length > 0
                    ? offerData.images?.all_images[0].url
                    : offerImg
                }
                alt=""
              />
            </div>
            <div className="d-flex align-items-center mt-4 mx-2">
              <h6 className="spplier-profile-label-color">Offer Name: </h6>

              <h6 className="ms-3 fw-semibold">{offerData?.name}</h6>
            </div>
            <div className="d-flex align-items-center mt-4 mx-2">
              <h6 className="spplier-profile-label-color">Description: </h6>

              <h6 className="ms-3 fw-semibold">{offerData?.description}</h6>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Offer Type: </h6>

                  <h6 className="ms-3 fw-semibold">
                    {offerData?.offer_type_label}
                  </h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">
                    Discount Type:{" "}
                  </h6>

                  <h6 className="ms-3 fw-semibold">
                    {offerData?.pricing?.offer_discount?.type}
                  </h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Usage Limit: </h6>

                  <h6 className="ms-3 fw-semibold">{`${offerData?.usage_limits?.global?.limit} uses`}</h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Code:</h6>

                  <h6 className="ms-3 fw-semibold">{offerData?.code}</h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Status:</h6>

                  <h6 className="ms-3 fw-semibold">
                    {offerData?.is_active ? "active" : "in active"}
                  </h6>
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">
                    Min Order amount :
                  </h6>

                  <h6 className="ms-3 fw-semibold">{`${offerData?.pricing?.min_order_amount} EGP`}</h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">
                    Discount Value:
                  </h6>

                  <h6 className="ms-3 fw-semibold">{`${offerData?.pricing?.offer_discount?.value}`}</h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">
                    Usage Limit per User:
                  </h6>

                  <h6 className="ms-3 fw-semibold">
                    {offerData?.usage_limits?.per_user?.limit}
                  </h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Offer Date:</h6>

                  <h6 className="ms-3 fw-semibold">
                    {new Date(offerData?.meta?.created_at).toLocaleDateString()}
                  </h6>
                </div>
                <div className="d-flex align-items-center mt-4 mx-2">
                  <h6 className="spplier-profile-label-color">Audience:</h6>

                  {/* <h6 className='ms-3 fw-semibold'>All Users</h6> */}
                </div>
              </div>
            </div>
            <div className="my-3">
              <h6 className="fw-semibold">2. Items Info:</h6>
              <div className="my-4">
                <Paper sx={{ height: 400, width: "100%" }}>
                  <DataGrid
                    rows={offerData?.items}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    sx={{ border: 0 }}
                  />
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OfferProfile